import { render, staticRenderFns } from "./InsideWindow.vue?vue&type=template&id=5bfe1f39&scoped=true&"
import script from "./InsideWindow.vue?vue&type=script&lang=ts&"
export * from "./InsideWindow.vue?vue&type=script&lang=ts&"
import style0 from "./InsideWindow.vue?vue&type=style&index=0&id=5bfe1f39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfe1f39",
  null
  
)

export default component.exports